import wordmark from './assets/aa-wordmark-horizontal-white.png';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const Logo: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => {
    const { AMERICAN_AUTONOMY } = useTranslation();

    return (
        <img
            alt={AMERICAN_AUTONOMY}
            className={`${className} ${styles.logo}`}
            data-testid={testId}
            src={wordmark}
        />
    );
};

export default Logo;
